import {Directive, ElementRef, HostListener, OnChanges, SimpleChanges} from '@angular/core';

@Directive({
    selector: '[appInputField]',
    standalone: false
})
export class InputFieldDirective implements OnChanges{
  ngOnChanges(changes: SimpleChanges){
    console.log(changes)
  }

  constructor(el: ElementRef) {
    if( el.nativeElement.value.trim() !== '' ) {
      el.nativeElement.parentNode.classList.add('input--filled' );
    }

    /*if (this.isChrome()) {
      let tries = 0;
      var timer = $interval(function () {
        tries++;
        if (tries > 5) {
          $interval.cancel(timer);
        }
        if (elm[0].matches("input[type=password]:-webkit-autofill")) {
          classie.add( elm[0].parentNode, 'input--filled' );
          // elm.parentNode.removeClass('input--filled');
          $interval.cancel(timer);
        }
      }, 100);
    }*/


    el.nativeElement.addEventListener( 'focus', this.onInputFocus );
    el.nativeElement.addEventListener( 'blur', this.onInputBlur );
    el.nativeElement.addEventListener( 'change', this.onInputFocus );
  }

  onInputFocus( ev ) {
    ev.target.parentNode.classList.add('input--filled');
  }

  onInputBlur( ev ) {

    if( ev.target.value.trim() === '' ) {
      ev.target.parentNode.classList.remove('input--filled');
    }
  }

  isChrome(){
    return navigator.userAgent.match(/chrome/i) && !navigator.userAgent.match(/edge/i);
  }

   isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

}
